var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovermentOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2411_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91675 89.1666H98.0834V98.0833H8.91675V89.1666ZM17.8334 53.5H26.7501V84.7083H17.8334V53.5ZM40.1251 53.5H49.0417V84.7083H40.1251V53.5ZM57.9584 53.5H66.8751V84.7083H57.9584V53.5ZM80.2501 53.5H89.1667V84.7083H80.2501V53.5ZM8.91675 31.2083L53.5001 8.91663L98.0834 31.2083V49.0416H8.91675V31.2083ZM17.8334 36.7188V40.125H89.1667V36.7188L53.5001 18.8855L17.8334 36.7188ZM53.5001 35.6666C52.3177 35.6666 51.1837 35.1969 50.3476 34.3608C49.5115 33.5247 49.0417 32.3907 49.0417 31.2083C49.0417 30.0259 49.5115 28.8919 50.3476 28.0558C51.1837 27.2197 52.3177 26.75 53.5001 26.75C54.6825 26.75 55.8165 27.2197 56.6526 28.0558C57.4887 28.8919 57.9584 30.0259 57.9584 31.2083C57.9584 32.3907 57.4887 33.5247 56.6526 34.3608C55.8165 35.1969 54.6825 35.6666 53.5001 35.6666Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2411_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovermentOrganization);
export default __webpack_public_path__ + "static/media/govermentOrganization.5bcef0442758a9d65028e394482d8cf8.svg";
export { ForwardRef as ReactComponent };